import { Button, Snackbar } from "@material-ui/core";
import React, { useState } from "react";
import UploadAndDownloadService from "../services/uploadAndDownloadFile";
import SocieteAndUserService from "../services/societeAndUser";
import {
  Alert,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Slide,
} from "@mui/material";


const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const ConfirmAddAdminAccount = ({
  setOnConfirmAddPersonnel,
  confirmPersonnelModel,
  setIsCancel,
}) => {
  const [open, setOpen] = React.useState(true);
  const [openAlert, setOpenAlert] = useState(false);
  const [openErrorAlert, setOpenErrorAlert] = useState(false);
  const [errorAlertText, setErrorAlertText] = useState();

  const [openInfoAlert, setOpenInfoAlert] = useState(false);
  const [infoAlertText, setInfoAlertText] = useState();

  const handleClose = () => {
    setOpen(false);
    setIsCancel(true);
    setOnConfirmAddPersonnel(false);
  };

  const handleCloseTwo = () => {
    setOpen(false);
    setIsCancel(false);
    setOnConfirmAddPersonnel(false);
  };

  const handleConfirm = () => {
    // setOpen(false);
    // setOnConfirmAddPersonnel(false);

    // {
    //          nom: personalName,
    //          prenom: personalPrenom,
    //          cin: personalCIN,
    //          email: personalEmail,
    //          numPhone: personalPhoneNumber,
    //          idSociete: personalSociete,
    //          idUserCreation: 0,
    //          mdp: personalPassword,
    //          remdp: personalPassword,
    //          file: file,
    //          localisation: personalLocalisation,
    //          camion: personalCamion,
    //        };

    let user = {
      cin: confirmPersonnelModel.cin,
      email: confirmPersonnelModel.email,
      firstName: confirmPersonnelModel.prenom,
      idRole: confirmPersonnelModel.roleIds,
      idSociete: confirmPersonnelModel.idSociete,
      idUserCreation: 0,
      lastName: confirmPersonnelModel.nom,

      phone: confirmPersonnelModel.numPhone,
      pwd: confirmPersonnelModel.mdp,
      rePWD: confirmPersonnelModel.remdp,
    };

    console.log("UserRegisterModel", user);

    if (confirmPersonnelModel.file != null) {
      const uploadData = new FormData();
      uploadData.append("picture", confirmPersonnelModel.file);
      let emailExist = false;

      UploadAndDownloadService.uploadFile(
        "/retail/uploadFile/uploadFile/UserPicture",
        uploadData
      )
        .then((response) => {
          if (Object.keys(response.data)[0] === "success") {
            user.fileUrl = response.data.success;

            SocieteAndUserService.addIwareClient(user)
              .then((response) => {
                if (Object.keys(response.data)[0] === "success") {
                  setOpenAlert(true);
                  setIsCancel(false);

                  //  setOpenS(true);
                  //  setErrorAlertText(
                  //    "Erreur : il ya un probléme de connection"
                  //  );
                } else if (Object.keys(response.data)[0] === "errorExist") {
                  setOpenInfoAlert(true);
                  setInfoAlertText("Info :Email déja exist");

                  emailExist = true;
                }
              })
              .catch(() => {
                setOpenErrorAlert(true);
                setErrorAlertText("Erreur : il ya un probléme de connection");
              });

            if (openAlert === true && emailExist === false) {
              setIsCancel(false);
              setTimeout(setOnConfirmAddPersonnel(false), 1000);
            }

            //  setMyProductModel(productModel);
          } else {
            setOpenErrorAlert(true);
            setErrorAlertText("Erreur : il ya un erreur  ");
          }
        })
        .catch(() => {
          setOpenErrorAlert(true);
          setErrorAlertText("Erreur : il ya un probléme de connection");
        });
    } else {
      //   dispatch(addNewProduct(productModel));

      setOpen(false);
      setOnConfirmAddPersonnel(false);
    }
  };

  const handleEroorClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenErrorAlert(false);
  };

  const handleInfoClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setOpenInfoAlert(false);
  };

  return (
    <>
      <Dialog
        open={true}
        TransitionComponent={Transition}
        keepMounted
        onClose={handleClose}
        aria-labelledby="alert-dialog-slide-title"
        aria-describedby="alert-dialog-slide-description"
      >
        <DialogTitle id="alert-dialog-slide-title">
          {"Confirmer vous l'ajout?"}
        </DialogTitle>
        <DialogContent>
          <DialogContentText id="alert-dialog-slide-description">
            <div class="card-body">
              <div class="row" style={{ marginTop: -20 }}>
                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Nom: </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmPersonnelModel.nom}{" "}
                  </label>
                </div>
                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Prénom: </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmPersonnelModel.prenom}{" "}
                  </label>
                </div>
                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">CIN: </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmPersonnelModel.cin}{" "}
                  </label>
                </div>
                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Email: </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmPersonnelModel.email}{" "}
                  </label>
                </div>
                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">Télephone: </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmPersonnelModel.numPhone}{" "}
                  </label>
                </div>
                <div className="form-group" class="col-sm-12">
                  <label htmlFor="inputName">mot de passe : </label>
                  <label
                    htmlFor="inputName"
                    style={{
                      marginLeft: 10,
                      color: "blue",
                      fontFamily: "Garamond",
                    }}
                  >
                    {confirmPersonnelModel.mdp}{" "}
                  </label>
                </div>
              </div>
            </div>
          </DialogContentText>
        </DialogContent>
        <DialogActions style={{ marginTop: -20 }}>
          <Button onClick={handleClose} color="primary">
            Annuler
          </Button>
          <Button onClick={handleConfirm} color="primary">
            Confirmer
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar
        open={openAlert}
        autoHideDuration={1000}
        onClose={handleCloseTwo}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleClose} severity="success">
          Ajout avec success !
        </Alert>
      </Snackbar>

      <Snackbar
        open={openErrorAlert}
        autoHideDuration={4000}
        onClose={handleEroorClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleEroorClose} severity="error">
          {errorAlertText}
        </Alert>
      </Snackbar>

      <Snackbar
        open={openInfoAlert}
        autoHideDuration={4000}
        onClose={handleInfoClose}
        anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
      >
        <Alert onClose={handleInfoClose} severity="info">
          {infoAlertText}
        </Alert>
      </Snackbar>
    </>
  );
};

export default ConfirmAddAdminAccount;
